import clsx from 'clsx'
import { type ComponentPropsWithRef, type ReactElement } from 'react'

import { useCtaTracking } from '@lib/hooks/use-cta-tracking'

import { ComponentCtaButtonType } from '@constants/enums/cta'
import { IconSprites } from '@constants/enums/sprites'

import { AllyText } from '@components/ui-core/ally-text/ally-text'
import { Icon } from '@components/ui-core/icon/icon'
import { Loader } from '@components/ui-core/loader/loader'

import styles from './hero-button.module.css'

export interface HeroButtonProps extends ComponentPropsWithRef<'a'> {
  text: string
}

export function HeroButton(props: HeroButtonProps): ReactElement {
  const { className, text, href, ...rest } = props
  const { trackAndNavigate, isLoading } = useCtaTracking({ placement: 'Hero' })

  return (
    <>
      <a
        className={clsx(styles.heroButton, className)}
        href={href}
        onClick={e =>
          href && trackAndNavigate(ComponentCtaButtonType.Signup, text, 'primary', href, e)
        }
        data-loading={isLoading ? true : undefined}
        aria-disabled={isLoading}
        inert={isLoading}
        {...rest}
      >
        <span className={styles.text}>{text}</span>
        <span className={styles.iconContainer}>
          {isLoading ? (
            <Loader size="medium" />
          ) : (
            <Icon variant={IconSprites.ArrowRight} className={styles.icon} />
          )}
        </span>
      </a>
      {isLoading && <AllyText text="Navigating to signup page...Please wait." aria-live="polite" />}
    </>
  )
}
